import React, {CSSProperties} from "react";
import {TicketPassengerTypeCartComponent} from "./ticket-passenger-type-cart.component";
import {useServices} from "../../../hooks/use-services.hook";
import {
    IJourneyShoppingCartViewModel
} from "../../../services/booking/models/shopping-cart/journey/journey-shopping-cart-view-model.interface";

interface TicketJourneyFaresComponentProps {
    journeyCart: IJourneyShoppingCartViewModel;
}

export const TicketJourneyFaresComponent: React.FC<TicketJourneyFaresComponentProps> = (props) => {
    const services = useServices();
    const theme = services.theme.currentTheme;

    const styles: CSSProperties = {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing.flexGap12,
        width: '100%',
        padding: theme.spacing.cardDefaultPadding,
        border: `1px solid ${theme.border.mainColor}`,
        borderRadius: theme.border.defaultRadius
    }

    const passengerTypesFares = props.journeyCart.passengerTypesShoppingCarts.filter(ptsc => ptsc.fareQuantity > 0);


    const hasInfants = Boolean(props.journeyCart.journeyInfantsShoppingCartModel);
    const renderInfantsFare = () => {
        const p = props.journeyCart.journeyInfantsShoppingCartModel;
        if(!p) {
            return null;
        }

        return (<TicketPassengerTypeCartComponent key={"INFANT_FLIGHT_CART"}
                                                  description={p.description}
                                                  fareQuantity={p.fareQuantity}
                                                  totalFareToDisplay={p.totalFareToDisplay}
                                                  isLastOne={true}/>)
    }


    return (
        <div style={styles}>
            {passengerTypesFares.map((p, index) => (<TicketPassengerTypeCartComponent key={p.uniqueKey}
                                                                                      description={p.description}
                                                                                      fareQuantity={p.fareQuantity}
                                                                                      totalFareToDisplay={p.totalFareToDisplay}
                                                                                      isLastOne={!hasInfants && (index === passengerTypesFares.length - 1)}/>))}

            {renderInfantsFare()}
        </div>
    )
}